<template>
  <span>
    <select v-if="displayType === 'form'" :disabled="readOnlyProp" name="" class="form-control"
            v-bind:value="modelValue" v-on:change="onChange($event.target.value)">
      <slot></slot>
      <option v-for="addressType in addressTypes" :value="addressType.addressType"
              :selected="addressType.addressType === defaultAddressType">
        {{ addressType.description }}
      </option>
    </select>
    <span v-if="displayType === 'label'">{{ addressTypeLabel }}</span>
  </span>
</template>

<script>
import MaintenanceService from '../endpoints/MaintenanceService'

const SESSION_ITEM_ADDRESS_TYPES = 'mdb/address_types'

export default {
    emits: ['update:modelValue','change'],
  name: 'address-type-input',

  props: {
    displayType: '',
    modelValue: { default: null },
    readOnlyProp: Boolean
  },
  data () {
    return {
      addressTypes: JSON.parse(sessionStorage.getItem(SESSION_ITEM_ADDRESS_TYPES)) || []
    }
  },
  computed: {
    defaultAddressType () {
      return this.modelValue
    },
    addressTypeLabel: function () {
      if (this.addressTypes && this.addressTypes.length > 0) {
        let addressType = this.addressTypes.find((el) => el.addressType === this.modelValue)
        if (addressType) return addressType.description
      }

      return ''
    }
  },
  methods: {
    loadAddressTypeList: function () {
      if (!this.addressTypes || this.addressTypes.length === 0) {
        MaintenanceService.loadAddressTypes()
          .then(response => {
            this.addressTypes = response.data
            sessionStorage.setItem(SESSION_ITEM_ADDRESS_TYPES, JSON.stringify(this.addressTypes))
          })
          .catch(error => {
            this.error = error.message
          })
      }
    },
    onChange (value) {
      this.$emit('update:modelValue', value)
        this.$emit('change', value)
    }
  },
  created () {
    this.loadAddressTypeList()
  }
}
</script>
